import {
  withFormsy,
} from 'formsy-react';

import InputSelectView from './InputSelectView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputSelectView);

const Component = InputComponent;

export default Component;
